import React, { useState } from "react";

import { DevOrgSwitcher, OrganizationProvider, ThemeMode, THEMES, useOrganization } from "@asd/customer-portal-ui";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { Navigation } from "./components/pages";
import KeycloakProvider from "./providers/KeycloakProvider";
import MapsProvider from "./providers/MapsProvider";
import ScramblerProvider from "./providers/ScramblerProvider";
import store from "./store/store";
import reportWebVitals from "./utils/reportWebVitals";

import "@asd/customer-portal-ui/fonts.css";
import "allotment/dist/style.css";
import "./index.css";

const Index = () => {
  const { key: orgKey, seo } = useOrganization();

  const [themeMode, setThemeMode] = useState<ThemeMode>("light");

  const theme = THEMES[orgKey][themeMode];

  const toggleThemeMode = () => setThemeMode((prev) => (prev === "light" ? "dark" : "light"));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Provider store={store}>
          <ScramblerProvider>
            <KeycloakProvider>
              <MapsProvider>
                <title>{seo.title}</title>
                <meta content={seo.description} name="description" />
                <meta content={seo.keywords} name="keywords" />
                <DevOrgSwitcher />
                <Navigation toggleThemeMode={toggleThemeMode} />
              </MapsProvider>
            </KeycloakProvider>
          </ScramblerProvider>
        </Provider>
      </BrowserRouter>
    </ThemeProvider>
  );
};

const useStrictMode = process.env.NODE_ENV === "development";
const IndexWrapper = useStrictMode ? React.StrictMode : React.Fragment;

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container missing in index.html");
}
const root = ReactDOM.createRoot(container);
root.render(
  <IndexWrapper>
    <OrganizationProvider>
      <Index />
    </OrganizationProvider>
  </IndexWrapper>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
